import React, { ReactNode } from 'react';

interface ShowProps {
  /**
   * Condition to determine if children should be rendered
   */
  when: boolean | unknown;
  /**
   * Optional fallback content to render when condition is false
   */
  fallback?: ReactNode;
  /**
   * Content to render when condition is true
   */
  children?: ReactNode;
}

/**
 * Conditional rendering component
 *
 * @example
 * ```tsx
 * // Simple conditional rendering
 * <Show when={isLoggedIn}>
 *   <UserProfile />
 * </Show>
 *
 * // With fallback
 * <Show when={isLoading} fallback={<Loader />}>
 *   <Content />
 * </Show>
 * ```
 */
export const Show: React.FC<ShowProps> = ({ when, fallback, children }) => {
  return <>{when ? children : fallback}</>;
};
